import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { get, size } from 'lodash';

import Element from '../../components/element';
import Text from '../../components/text';
import Flex from '../../components/flex';
import { colors } from '../../config/theme';
import { apiRequest } from '../../api/actions';
import { ReactComponent as IconChevronRight } from '../../assets/icons/IconChevronRight.svg';
import { getTimeWithAmOrPm } from '../../utils';

const PastVisits = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [pastVisits, setPastVisits] = useState([]);
  const getPastVisits = () => {
    const request = {
      method: 'get',
      url: `/visit?status=past`
    };
    const meta = {
      onSuccess: res => {
        setPastVisits(res.data.data.list);
      }
    };

    dispatch(apiRequest(request, meta));
  };

  const getFormattedDate = data => {
    let date = moment(data.scheduledDate).format('YYYY-MM-DD');
    return moment(`${date} ${data.scheduledTime}`).format(
      'MMMM Do, YYYY [at] hh:mm A'
    );
  };
  const navigateToIndividualVisit = each => {
    navigate('individualVisit', {
      replace: true,
      state: {
        visit: each
      }
    });
  };

  useEffect(() => {
    getPastVisits();
  }, []);

  return (
    <Element>
      <Element paddingBottom="30px" borderBottom="1px solid #e2e2e2">
        <Text family="GTAM" size="21px" color={colors.mineShaft}>
          Past Visits
        </Text>
      </Element>
      <Element marginBottom="20px">
        {size(pastVisits) > 0 &&
          pastVisits.map(each => {
            return (
              <Flex
                align="center"
                justify="space-between"
                onClick={() => navigateToIndividualVisit(each)}
                borderBottom="1px solid #e2e2e2"
              >
                <Element>
                  <Text
                    family="GTAR"
                    size="21px"
                    color={colors.mineShaft}
                    marginBottom="0px"
                  >
                    {/* {getFormattedDate(each)} */}
                    {`${moment(
                      each.scheduledDate.substring(
                        0,
                        each.scheduledDate.indexOf('T')
                      )
                    ).format('MMMM Do, YYYY')}`}  at  {`${getTimeWithAmOrPm(each.scheduledTime)}`}
                  </Text>
                  <Text
                    family="GTAR"
                    size="14px"
                    color={colors.dustyGray}
                    marginBottom="15px"
                    marginTop="5px"
                  >
                    {get(each, 'clinic.fullAddress')}
                  </Text>
                </Element>
                <Element>
                  <Element type={IconChevronRight} width="24px" height="24px" />
                </Element>
              </Flex>
            );
          })}
        {size(pastVisits) === 0 && (
          <Element marginTop="40px" textAlign="center">
            <Text family="GTAM" size="21px" color={colors.dustyGray}>
              No past visits to display.
            </Text>
          </Element>
        )}
      </Element>
    </Element>
  );
};

export default PastVisits;
